import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'

export class LoginReportMailApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/loginReportMail',
      requesterInfo,
    })
  }

  // Login raporunun kodda gömülü alıcısı yoktur: Mails zorunludur.
  public async sendLoginReportMail(req: { Company?: number | null; Mails: string[] }): Promise<any> {
    return await this.postAsync<any>(req)
  }
}
